import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';

import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import HotTub from '@material-ui/icons/HotTub';
import MeetingRoom from '@material-ui/icons/MeetingRoom';
import LocationOn from '@material-ui/icons/LocationOn';
import Link from '@material-ui/icons/Link';
import Star from '@material-ui/icons/Star';

import ImageCarousel from '../ImageCarousel';
import { PROPERTY_FILES_FOLDER } from '../../constants';

const styles = theme => ({
  paper: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    display: 'flex',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    flexGrow: 1,
  },
  paragraph: {
    marginTop: 0
  },
  redText: {
    color: '#b20000'
  },
  startIcon: {
    color: '#FFD700'
  },
  pointer: {
    cursor: 'pointer'
  }
});

class PropertyDetails extends Component {
  static propTypes = {
    classes: PropTypes.object,
    handleSubmit: PropTypes.func,
    dakk: PropTypes.object,
    user: PropTypes.object,
    removeMessage: PropTypes.func,
    buttonText: PropTypes.string,
    formType: PropTypes.string,
    error: PropTypes.string
  };


  render() {
    const {
      classes,
      propertyDetails
    } = this.props;

    const user = propertyDetails.userDetails || {};

    const ratings = propertyDetails.reviews || [];
    let count = 0;

    ratings.forEach(r => {
      count = count + r.rating;
    });

    const propertyRating = Math.round((count / ratings.length) * 100) / 100;

    return (
      <React.Fragment>
        <Paper className={classes.paper}>
          <Grid container spacing={24}>
            <Grid container spacing={24}>
              <Grid item xs={8} sm={8}>
              { 
                propertyDetails.images && 
                <ImageCarousel 
                  images={propertyDetails.images}
                  folderName={PROPERTY_FILES_FOLDER}
                />
              }
              
              </Grid>
              <Grid item xs={4} sm={4}>
                <p className={classes.paragraph}>
                  <Typography variant="caption">
                    Posted By: {user.firstName} {user.lastName}
                  </Typography>

                  <Typography variant="h6">
                    {propertyDetails.address}
                  </Typography>

                  {/* <Star color='inherit' className={classes.startIcon}/>
                  <Star color='inherit' className={classes.startIcon}/>
                  <Star color='inherit' className={classes.startIcon}/> */}

                  <Typography variant="subtitle2">
                    <Link className={classes.pointer} onClick={() => propertyDetails.videoLink && window.location.assign(propertyDetails.videoLink)}/> <a href={`http://maps.google.co.in/maps?q=${propertyDetails.address}${propertyDetails.city}${propertyDetails.country}`} target="_blank" rel="noopener noreferrer"><LocationOn className={classes.pointer}/></a>
                  </Typography>

                  <Typography variant="subtitle2" className={classes.redText}>
                    $ {propertyDetails.rentAmount}
                   </Typography>

                  <Typography variant="subtitle2">
                    <HotTub /> {propertyDetails.bathrooms} Bathroom
                   </Typography>

                  <Typography variant="subtitle2">
                    <MeetingRoom /> {propertyDetails.bedrooms} Bedroom
                  </Typography>

                  <Typography variant="subtitle2">
                    Lease Term: <span className={classes.redText}>{propertyDetails.leaseTerm} Days
                    </span>
                  </Typography>

                  <Typography variant="subtitle2">
                    Pet Friendly: <span className={classes.redText}>{propertyDetails.isPet ? 'Yes' : 'No'}
                    </span>
                  </Typography>

                  <p></p>
                  <Typography variant="body2">
                    {propertyDetails.comment}
                  </Typography>
                </p>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(PropertyDetails);